import {fetchDataset} from '../../core/fetchDataset';

/**
 * Datasets the agent may read from this browser.
 *
 * Registered as a plugin rather than imported by the bridge provider,
 * because that is how every other handler here that calls Canvas reaches the
 * provider. The provider holds the command wiring; the modules that actually
 * talk to the API are pulled in by whoever registers them. Importing this
 * one directly put axios into the provider's module graph and broke a test
 * that had every right to expect otherwise.
 *
 * Not a resource in the Canvas sense - there is no Datasets page and nothing
 * to navigate to. It is a plugin because the registry is how handlers are
 * published, and a second mechanism for one collection would be worse.
 *
 * Both sources are served by the same reader. Which one was asked for is a
 * parameter, and what each of them means is declared once in
 * core/datasetSources.js beside the URL it reads.
 */
const datasetsPlugin = {
	id: 'datasets',
	version: 1,
	commandVersion: 1,
	resource: 'datasets',
	datasets: {
		'ap.inventory': fetchDataset,
		'client.inventory': fetchDataset,
		'dashboard.counts': fetchDataset,
	},
};

export default datasetsPlugin;
